<template>
    <div class="" style="margin-top: 32px;">
        <Alert type="warning" show-icon closable v-if="noChanges" @on-close="noChanges=false">Nothing to update</Alert>
        <Row type="flex" align="middle" class="code-row-bg" v-show="firmwareForm._id">
            <Form ref="firmwareForm" :model="firmwareForm" :rules="firmwareModuleRules">
                <i-col :xs="8">
                    <Upload action="" :before-upload="beforeDocumentUpload" :show-upload-list="false">
                        <Button icon="ios-cloud-upload-outline">Binary file</Button>
                    </Upload>
                </i-col>
                <i-col :xs="16">
                    <FormItem prop="FileName">
                        <i-input v-model="firmwareForm.FileName" type="text" placeholder="File Name" :disabled="!firmwareForm.WinkyBinary" />
                    </FormItem>
                </i-col>
                <i-col :xs="24" style="margin-top: 16px;">
                    <FormItem prop="FirmwareVersion" label="F/W version: ">
                        <InputNumber :min="1" v-model="firmwareForm.FirmwareVersion"></InputNumber>
                    </FormItem>
                    <FormItem prop="FirmwareDescription">
                        <Input v-model="firmwareForm.Description" type="textarea" placeholder="Description" :autosize="{minRows: 5,maxRows: 5}" />
                    </FormItem>
                </i-col>
            </Form>
        </Row>
        <Row type="flex">
            <i-col :xs="{span:12,offset:12}" v-if="showUpdate">
                <Button long
                        type="success"
                        :loading="submitUpdateLoading"
                        @click="handleUpdate()"
                >       <span v-if="!submitUpdateLoading">Update Firmware</span>
                    <span v-else>Processing...</span>
                </Button>
            </i-col>
        </Row>
        <Spin size="large" fix v-if="spinShow">
            <Icon type="ios-loading" size=32 class="spin-icon-load"></Icon>
        </Spin>
    </div>

</template>

<script>
    import { getFirmware, updateFirmware } from "../../_services/firmware.service";
    import { bus } from "../../main";

    export default {
        props:['hardwareData','moduleFirmwares'],
        data() {
            const validateFile = (rule, value, callback) => {
                let duplicateFile=this.moduleFirmwares.reduce((duplicates,firmware)=>{
                    if( firmware.FirmwareFileName===this.firmwareForm.FileName &&
                        firmware._id!==this.firmwareForm._id){
                        duplicates.push(firmware)
                    }
                    return duplicates
                },[])
                if(duplicateFile.length){
                    callback(new Error('File already in use on another firmware.'));
                }else{
                    callback();
                }
            };
            const validateVersion = (rule, value, callback) => {
                let duplicateVersion=this.moduleFirmwares.reduce((duplicates,firmware)=>{
                    if( firmware.FirmwareVersion===this.firmwareForm.FirmwareVersion &&
                        firmware._id!==this.firmwareForm._id){
                        duplicates.push(firmware)
                    }
                    return duplicates
                },[])
                if(duplicateVersion.length){
                    callback(new Error('F/W version already exist.'));
                }else{
                    callback();
                }
            };
            return {
                submitUpdateLoading:false,
                submitLoading:false,
                noChanges:false,
                showUpdate:false,
                hardwareModuleData:Object.assign({},this.hardwareData),
                firmwareForm: {
                    _id:null,
                    hardware:"",
                    FirmwareVersion:1,
                    Description:'',
                    FileName:'',
                    WinkyBinary:null,
                },
                currentFile:{name:''},
                file:{name:''},
                currentUpdateData:{
                    _id:null,
                    hardware:"",
                    FirmwareVersion:1,
                    Description:'',
                    FileName:'',
                    WinkyBinary:null,
                },
                firmwareModuleRules: {
                    FileName:[
                        { validator: validateFile, trigger: 'blur' }
                    ],
                    FirmwareVersion: [
                        { validator: validateVersion, trigger: 'blur' }
                    ]
                },
                spinShow:false,
            };
        },
        methods: {
            setUpdateData(data){
                let vm=this
                vm.noChanges=false
                vm.spinShow=true
                if(this.currentUpdateData._id){
                    vm.spinShow=false
                    if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.firmwareForm)){
                        this.$Modal.confirm({
                            title: 'Unsaved Changes',
                            content: `Changes made on firmware version ${this.currentUpdateData.FirmwareVersion} is not yet saved? Do you wish to save it first?`,
                            okText: 'Save',
                            cancelText: 'Discard',
                            onOk:() => {
                                this.handleUpdate(data)
                            },
                            onCancel: () =>{
                                this.getFirmwareModuleData(data)
                                this.$emit('setActive',data)
                            }
                        });
                    }else{
                        this.getFirmwareModuleData(data)
                        this.$emit('setActive',data)
                    }
                }else {
                    this.getFirmwareModuleData(data)
                    this.$emit('setActive',data)
                }
            },
            beforeDocumentUpload(file) {
                this.file = file;
                this.firmwareForm.WinkyBinary = file;
                this.firmwareForm.FileName=file.name.substr(0, file.name.lastIndexOf('.'))
                return false;
            },
            getFirmwareModuleData(data){
                let vm=this
                vm.resetForm()
                getFirmware(data._id).then(async res=>{
                    vm.showUpdate=true
                    vm.firmwareForm=res.data.data
                    vm.firmwareForm._id=data._id
                    let cpData=Object.assign({},res.data.data)
                    cpData._id=data._id
                    vm.currentUpdateData=cpData
                    vm.currentFile=cpData.FileName
                    vm.spinShow=false
                }).catch(err=>{
                    vm.spinShow=false
                })
            },
            resetForm(){
                this.showUpdate=false
                this.file={name:''}
                this.currentUpdateData={
                    _id:null,
                    hardware:"",
                    FirmwareVersion:1,
                    Description:'',
                    FileName:'',
                    WinkyBinary:null,
                }
                this.firmwareForm={
                    _id:null,
                    hardware:"",
                    FirmwareVersion:1,
                    Description:'',
                    FileName:'',
                    WinkyBinary:null,
                }
                if(this.$refs.firmwareForm) {
                    this.$refs.firmwareForm.resetFields();
                }
            },
            handleUpdate(nexData) {
                // if(method==='create' && this.firmwareForm._id) {
                //     this.showUpdate=false
                //     delete this.firmwareForm.id;
                //     this.$emit('unsetActive');
                // }
                if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.firmwareForm)){
                    this.noChanges=false
                    this.$refs.firmwareForm.validate(valid => {
                        if (valid) {
                            this.submitUpdateLoading=true
                            if(this.firmwareForm.WinkyBinary===null){
                                delete this.firmwareForm.WinkyBinary
                            }
                            updateFirmware(this.firmwareForm._id,this.firmwareForm).then(res => {
                                this.$Message.success(`Successfully updated firmware!`);
                                this.submitUpdateLoading = false
                                this.$emit('getFirmwares',{hardware:this.hardwareModuleData},'update');
                                this.$emit('setActive',null)
                                this.currentUpdateData = Object.assign({},res.data.data)
                                if(nexData){
                                    this.$emit('setActive',nexData)
                                    this.getFirmwareModuleData(nexData)
                                }
                                this.resetForm()
                            }).catch(err => {
                                bus.$emit('requestError',err)
                                this.submitUpdateLoading = false
                                this.$emit('getFirmwares',{hardware:this.hardwareModuleData},'update');
                                this.$emit('setActive',null)
                                this.resetForm()
                                // this.$Message.error('Failed to update firmware. Please try again later.')
                                this.$Message.error(err.response.data.message)
                            })

                        }
                    });
                }else{
                    this.noChanges=true
                }
            },
        },
        mounted() {
            bus.$on('hardwareChanged', (data) => {
                this.resetForm()
                if(data) {
                    this.hardwareModuleData = Object.assign({},data.hardware)
                }else{
                    this.resetForm()
                }
            });
        }
    };
</script>
<style scoped>

</style>
